import React, {Fragment} from 'react';
import Box from '../layout/Box';
import createEditor from '../form/ComponentEditor';
import classNames from "classnames";
import BoxEditor from "./BoxEditor";
import InvoiceList from "./lists/invoiceList";
import InvoiceForm from "./forms/invoiceForm";
import SzamlazzForm from "./forms/Invoice/SzamlazzForm";
import ExternalInvoiceForm from "./forms/Invoice/ExternalInvoiceForm";
import isEqual from 'lodash-es/isEqual';
import Button from "../form/Button";
import PrintButton from "../form/PrintButton";
import {postData} from "../../utils/request";
import connect from "react-redux/es/connect/connect";
import TransactionPaymentEditor from "./TransactionPaymentEditor";

export const providerTypes = {
    ExternalInvoice:  ordertype => ordertype + "" === "ExternalInvoice",
    Szamlazz: ordertype => ordertype + "" === "Szamlazz",
};

export const invoiceTypes = {
    STORNO: state => state + "" === "0",
    INVOICE: state => state + "" === "1",
    CORRECTIVE: state => state + "" === "2",
    PROFORM: state => state + "" === "999",
    EDITABLE: state => state + "" === "666",
};

class invoiceEditor extends React.Component {

    state = {
        edit: false,
        allExternal: false
    };

    constructor(props) {
        super(props);
        this.state.edit = !isEqual(this.props.values, this.props.initialValues);
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        const values = {serviceprovider_type: "ExternalInvoice", type: "999", ...this.state.allExternal};
        await this.props.setInitialValues(values);
        await this.props.setFormValues(values);
        this.editor && this.editor.focus();
    }

    updateInvoice = async (event) => {
        await this.props.saveForm(event);
        this.setState({edit: false});
        this.list && this.list.refresh();
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (prevProps.values[this.props.componentConfig.idfield] !== this.props.values[this.props.componentConfig.idfield]) {
            this.setState({edit: false});
        }
    }

    cancelEdit = async () => {
        await this.props.initialForm();
        this.setState({edit: false});
    }

    sendMail = async () => {
        const values = this.props.values;
        const idfield = this.props.componentConfig.idfield;
        await this.props.processAction(async () => {
            return await postData({
                action: "invoice.sendMail",
                [idfield]: values[idfield]
            })
        });
    }

    createProform = async () => {
        const values = this.props.values;
        const idfield = this.props.componentConfig.idfield;
        await this.props.processAction(async () => {
            return await postData({
                action: "invoice.createProform",
                [idfield]: values[idfield]
            })
        });
    }

    render() {

        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;

        const stornoable = !this.props.values.storno && !invoiceTypes.PROFORM(this.props.values.type) && !invoiceTypes.EDITABLE(this.props.values.type);
        const correctable =
            !providerTypes.ExternalInvoice(this.props.values.serviceprovider_type) && !(invoiceTypes.EDITABLE(this.props.values.type) || invoiceTypes.PROFORM(this.props.values.type));
        const acting = ((this.props.values || {}).acting || {}).partner_id;
        const currentPartner = (((this.props.till || {}).pos || {}).partner || {}).partner_id;

        let Form = InvoiceForm;
        switch ((this.props.values || {}).serviceprovider_type) {
            case "Szamlazz": Form = SzamlazzForm; break;
            case "ExternalInvoice": Form = ExternalInvoiceForm; break;
            default: Form = InvoiceForm; break;
        }

        const actionButtons = [];
        const processButtons = [];
        if (this.state.allExternal) {
            processButtons.push(
                <Button
                    key="0"
                    disabled={this.props.isLoading}
                    color="default"
                    onClick={this.pristineForm}
                >
                    Új
                </Button>
            );
            if (invoiceTypes.PROFORM(this.props.values.type)) {
                actionButtons.push(
                    <Button
                        key="1"
                        disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                        color="danger"
                        className="pull-left"
                        onClick={this.props.deleteForm}
                    >
                        Törlés
                    </Button>
                );
            }
        }
        if (!this.props.values.billnum && invoiceTypes.PROFORM(this.props.values.type)) {
            actionButtons.push(
                <Button
                    key="9"
                    disabled={!this.props.values[this.props.componentConfig.idfield]}
                    color="default"
                    className="pull-right"
                    onClick={this.createProform}
                >
                    Proforma készítése
                </Button>
            );
        }

        return (
            <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header={"Számlák"}
                    footer={processButtons}
                >
                    <InvoiceList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} isAllExternal={(allExternal) => this.setState({allExternal})} />
                </List>
                {(this.props.values[this.props.componentConfig.idfield] || this.state.allExternal) && <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={(this.props.values.billnum || "") + " Számla"}
                    footer={
                        !this.state.edit ?
                            <Fragment>
                                {this.props.values.billnum && !this.state.edit && <PrintButton
                                    {...this.props}
                                    color="primary"
                                    className="pull-right"
                                    disabled={this.props.isLoading}
                                />}
                                {
                                    !correctable
                                    ?
                                        <Fragment>
                                            <Button
                                                key="0"
                                                disabled={!this.props.dirty || this.props.isLoading}
                                                color="primary"
                                                className="pull-right"
                                                onClick={this.props.saveForm}
                                            >
                                                Mentés
                                            </Button>
                                            {actionButtons}
                                        </Fragment>
                                    :
                                        (stornoable && <Button
                                            onClick={() => this.setState({edit: true})}
                                            disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                                            color="warning"
                                            className="pull-right"
                                        >
                                            Javítás
                                        </Button>)
                                }
                                {acting + "" === "" + currentPartner && <Button
                                    onClick={this.sendMail}
                                    disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.values.sent + "" === "" + this.props.values.type || this.props.isLoading}
                                    color="warning"
                                    icon={{lib: "far", name: "paper-plane"}}
                                    className="pull-right"
                                >
                                    Küldés
                                </Button>}
                            </Fragment>
                            :
                            <Fragment>
                                <Button
                                    onClick={this.updateInvoice}
                                    disabled={!this.props.values[this.props.componentConfig.idfield] || !this.props.dirty || this.props.isLoading}
                                    color="primary"
                                    className="pull-right"
                                >
                                    Javítás
                                </Button>
                                <Button
                                    onClick={this.cancelEdit}
                                    disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                                    color="default"
                                    className="pull-right"
                                >
                                    Mégse
                                </Button>
                            </Fragment>
                    }
                >
                    <Form {...this.props} providerTypes={providerTypes} invoiceTypes={invoiceTypes} correctable={correctable} edit={!correctable || this.state.edit} />
                </Editor>}
                {this.props.values[this.props.componentConfig.idfield] && <TransactionPaymentEditor
                    presets={{transaction: this.props.values.transaction.id}}
                    listFilter={[{
                        field: "transaction",
                        value: this.props.values.transaction.id
                    }]}
                />}
            </Fragment>
        );
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(createEditor({
    componentName: "invoice",
    WrappedComponent: invoiceEditor,
    props: {
        view: "admin",
        componentActions: (action, data, params, componentConfig) => {
            if (!providerTypes.ExternalInvoice(data.serviceprovider_type) && !(invoiceTypes.EDITABLE(data.type) || invoiceTypes.PROFORM(data.type))) {
                return {
                    action: "updateInvoice",
                    data: {
                        [componentConfig.idfield]: data[componentConfig.idfield],
                        accountdate: data.accountdate,
                        transactiondate: data.transactiondate,
                        deadline: data.deadline,
                        comment: data.comment,
                    },
                    params
                };
            } else {
                return {action,data,params};
            }
        }
    }
}));

